import withModal from '../modal/withModal';
import ExternalShippingAddressForm from './ExternalShippingAddressForm';

export const EXTERNAL_SHIPPING_ADDRESS_FORM_MODAL =
  'EXTERNAL_SHIPPING_ADDRESS_FORM_MODAL';

const ExternalShippingAddressFormModal = withModal(
  ExternalShippingAddressForm,
  {
    name: EXTERNAL_SHIPPING_ADDRESS_FORM_MODAL,
    size: 'xs',
    type: 'full',
    contentLabel: 'Edit Contact',
    overlayClassName: 'z-modal-max',
    className: 'external-shipping-address-form-modal',
  },
);

export default ExternalShippingAddressFormModal;
